
























import { Component, Vue, Prop } from "vue-property-decorator";
import _ from "lodash";

@Component
export default class ThousandNumberInput extends Vue {
    protected inEdition: boolean = false;
    @Prop(Number) protected value!: number|null;
    @Prop({type: Boolean, default: false }) protected disabled!: boolean;
    @Prop({type: String, default: "medium" }) protected size!: string;
    @Prop({default: 2 }) protected precision!: any;
    @Prop({type: Number, default: null  }) protected precisionToShow!: number;

    get displayedValue() {
        const precision = this.precisionToShow ? this.precisionToShow : this.precision;

        if (this.value) {
            return _.invoke(this.$options.filters, "number", this.value, precision);
        }

        return _.invoke(this.$options.filters, "number", 0, precision);
    }

    get precisionProccessed() {
        if (this.precision === "disabled") {
            if (this.value) {
                const str = this.value.toString().split(".");
                if (str[1]) {
                    return str[1].length;
                }
            }

            return 0;
        }

        return this.precision;
    }

    protected goToEdition() {
        this.inEdition = true;

        this.$nextTick(() => {
            const editInput = _.get(this.$refs, "editInput", null);
            if (editInput) {
                _.invoke(editInput, "focus");
            }
        });
    }

    protected exitEdition() {
        this.inEdition = false;
    }
}
